import { Box, CircularProgress, Typography } from '@mui/material';
import React, { memo } from 'react';

interface Props {
    loading?: string,
    color?: string
}

const Loading: React.FC<Props> = ({ loading,color }) => {
    return (
        <Box sx={{ maxWidth: 600, margin: 'auto', textAlign: 'center', mt: '10%', mb: '10%' }} >
            <CircularProgress sx={{ mb: 3, color: color ?? 'primary' }} />
            <Typography sx={{ color: color ?? 'text.default' }}>
                {loading ? loading : 'Loading...'}
            </Typography>
        </Box>
    )
};

export default memo(Loading);